import { useQueryClient } from '@tanstack/react-query';
import { type OnboardingTourStep, createOnboardingTourStep } from 'models';
import { useMutation } from 'query';
import { updateOnboardingStep } from '../../services';
import { getOnboardingTourStepsQueryKey } from '../keys';

export const useUpdateOnboardingStep = () => {
  const queryClient = useQueryClient();

  return useMutation<OnboardingTourStep, { calendars?: string[]; id: string; status: 'completed' }>({
    async mutationFn({ calendars, id, status }) {
      // TODO is not nice that request types are not separated on application logic
      const { data: onboardingStep } = await updateOnboardingStep(id, {
        /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
        meta: calendars ? { selected_calendar_options: calendars } : undefined,
        status,
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createOnboardingTourStep(onboardingStep);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getOnboardingTourStepsQueryKey() });
    },
  });
};
